 
export class storeIcuAction {
    static readonly type = '[icuass] icuass';

    constructor(public payload: any) {
        console.log(payload)
    }
}
export class storeAssessmentAction {
    static readonly type = '[icuass1] icuass1';

    constructor(public payload: any) {
    }
}
export class storeNurisngAction {
    static readonly type = '[nursing] nursing';

    constructor(public payload: any) {
    }
}